import { Accept } from 'react-dropzone/.';

import { DEFAULT_FILE_UPLOAD_MAX_SIZE, MB } from '@/constants';
import { mergeClasses } from '@/utils';

import { Dropzone, DropzoneEmptyState } from '@/components/common';

const envMaxSize =
  Number(process.env.REACT_APP_DEFAULT_FILE_UPLOAD_MAX_SIZE) || DEFAULT_FILE_UPLOAD_MAX_SIZE;

interface IFileUpload {
  error?: string;
  accept: Accept;
  onDrop: (files: File[]) => void;
  onError: (error: string) => void;
  customTypeMessage?: string;
  customSizeMessage?: string;
  maxSize?: number;
  variant?: 'default' | 'compact';
  className?: string;
  disabled?: boolean;
}

export const FileUpload = ({
  error,
  onDrop,
  onError,
  accept,
  customTypeMessage,
  customSizeMessage,
  maxSize,
  variant = 'default',
  className,
  disabled,
}: IFileUpload) => {
  const maxFileSize = maxSize ?? envMaxSize;
  const parseError = (err: Error) => {
    if (err.message.includes('File type must be')) {
      onError('File format not supported. Allowed file types: PDF.');
    } else if (err.message.includes('File is larger than')) {
      onError('File is too large. File size limit: ' + maxFileSize / MB + 'MB');
    } else if (err.message.includes('Too many files')) {
      onError('Multiple files detected. Please upload a single PDF document only.');
    } else {
      onError(err.message);
    }
  };

  return (
    <Dropzone
      accept={accept}
      maxSize={maxFileSize}
      onDrop={onDrop}
      onError={parseError}
      error={error}
      disabled={disabled}
      className={mergeClasses('w-[432px] h-[200px]', variant === 'compact' && '!h-12', className)}
      variant={variant}
    >
      <DropzoneEmptyState
        variant={variant}
        customTypeMessage={customTypeMessage}
        customSizeMessage={customSizeMessage}
      />
    </Dropzone>
  );
};
